import { combineActions, handleActions } from 'redux-actions';
import { shop as actions } from '../../../actions';

const initialState = {
  details: {},
  isFetchingStoreDetails: true,
  isFetchingOrder: true,
  order: undefined,
  isCreating: false,
  isCreatingOrderError: false,
  isMissingDetails: false,
  businessName: '',
};

const shop = handleActions<any, any>({
  [combineActions(
    actions.getStoreDetails,
    actions.receiveStoreDetails,
    actions.getOrder,
    actions.receiveOrder,
    actions.createOrder,
    actions.createOrderFailure,
    actions.setBusinessName,
    actions.setStoreDetails,
  ) as any]: (state: any, action: any): any => ({
    ...state,
    ...action.payload,
  }),
}, initialState);

export default shop;
